import { createFileRoute } from "@tanstack/react-router"
import StaffReviewWorkspace from "@/routes/-pages/StaffReviewWorkspace"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"

export const Route = createFileRoute(
  "/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId",
)({
  validateSearch: validateInstructorSectionSearch,
  component: StaffReviewUserWorkspaceRoute,
})

function StaffReviewUserWorkspaceRoute() {
  const { courseId, assessmentId, revieweeId } = Route.useParams()
  const { sectionId } = Route.useSearch()

  return (
    <StaffReviewWorkspace
      courseId={courseId}
      assessmentId={assessmentId}
      targetId={revieweeId}
      targetType="user"
      sectionId={sectionId}
    />
  )
}
